import React from "react";
import PackagesTabContent from "./PackagesTabContent";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1619 },
    items: 4,
    slidesToSlide: 1,
  },
  laptop: {
    breakpoint: { max: 1619, min: 1024 },
    items: 3,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 640 },
    items: 2,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 639, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};

const carouselParams = {
  additionalTransfrom: 0,
  arrows: false,
  autoPlay: false,
  autoPlaySpeed: 3000,
  centerMode: false,
  className: "",
  containerClass: "carousel-container",
  dotListClass: "",
  draggable: true,
  focusOnSelect: false,
  infinite: true,
  itemClass: "",
  keyBoardControl: true,
  minimumTouchDrag: 80,
  renderButtonGroupOutside: true,
  renderDotsOutside: false,
  responsive: responsive,
  showDots: false,
  sliderClass: "",
  slidesToSlide: 1,
};

const PackagesTab = (props) => {
  const { data, carousel } = props;
  return (
    <>
      {carousel == false ? (
        <div className="row">
          <div
            className="d-flex justify-content-between align-items-center tz"
            id="home-pricing-web"
          >
            <div className="row tz-outer">
              <div className="row tz">
                {data?.map((item) => (
                  <PackagesTabContent
                    item={item}
                    key={item.id}
                    carousel={carousel}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="row">
          <div
            className="d-flex justify-content-between align-items-center tz"
            id="home-pricing-web"
          >
            <div className="row tz-outer">
              <div className="row tz">
                {/* <Carousel {...carouselParams}> */}
                {data?.map((item) => (
                  <PackagesTabContent
                    item={item}
                    key={item.id}
                    carousel={carousel}
                  />
                ))}
                {/* </Carousel> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PackagesTab;
